export class TableSector {
  id: number;
  name: string;
  status?: boolean;
  active?: boolean;

  constructor(obj: any = {}) {
    Object.assign(this, obj);

    if (!this.name) this.name = '';
    if (this.status == null) this.status = true;
  }
}

export class TableSectorConfig {
  id: number;
  tableQuantity: number;
  seatQuantity: number;
  status: boolean;
  sectorId: number;
  storeId: number;
  sectorName: string;
  reservationFee: number;

  constructor(obj: any = {}, reservationFee?: number) {
    Object.assign(this, obj);

    if (this.status == null) this.status = true;

    if (!this.reservationFee) {
      this.reservationFee = reservationFee || 0;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/reservation/models/table-sector.model.ts